module.exports = __webpack_public_path__ + "img/prescription.a30a7c8c.svg";